import { BlocksViewNode, BlocksViewVisualState, ItemSet } from '../types';
import { createItemSet } from '../view/itemSet';

export const getLinked = (node: BlocksViewNode): ItemSet => {
  // blocks diagram does this funky lowlight effect where it displays
  // everything except the hover node and all linked nodes and associated links as
  // lowlit
  //
  // this is ok, I guess, but it's only really one of the possible "follow the links"
  // style things to do (another one is to not do anything)

  const ret = createItemSet(BlocksViewVisualState.Highlight);

  const explore = (node: BlocksViewNode) => {
    if (ret.has(node)) {
      return;
    }

    ret.add(node);

    for (const link of node.links ?? []) {
      if (!ret.has(link)) {
        ret.add(link);

        explore(node === link.target ? link.source : link.target);
      }
    }
  };

  explore(node);

  return ret;
};
